"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _loading = _interopRequireDefault(require("./loading.gif"));
var _empty = _interopRequireDefault(require("./empty.png"));
var LoadingImage = function LoadingImage(props) {
  var image = props.image,
    styleClass = props.styleClass,
    altText = props.altText,
    titleText = props.titleText,
    onClickFunc = props.onClickFunc,
    loadingImage = props.loadingImage,
    placeholderImage = props.placeholderImage;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imageLoading = _useState2[0],
    setImageLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(image),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    renderedImage = _useState4[0],
    setRenderedImage = _useState4[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
    "data-testid": "ImageLoading",
    className: styleClass,
    src: loadingImage,
    hidden: !imageLoading,
    alt: "Loading..."
  }), /*#__PURE__*/_react["default"].createElement("img", {
    "data-testid": "ImageRendered",
    className: styleClass,
    onLoad: function onLoad() {
      setImageLoading(false);
    },
    onError: function onError() {
      setRenderedImage(placeholderImage);
      setImageLoading(false);
    },
    hidden: imageLoading,
    src: renderedImage || placeholderImage,
    alt: altText,
    title: titleText,
    onClick: onClickFunc
  }));
};
LoadingImage.defaultProps = {
  loadingImage: _loading["default"],
  placeholderImage: _empty["default"],
  image: undefined,
  styleClass: '',
  altText: undefined,
  titleText: '',
  onClickFunc: function onClickFunc() {}
};
var _default = LoadingImage;
exports["default"] = _default;